(function(){
  'use strict';

  const ASSETS = {
    bg:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/worldbackground.png?v=1778850332',
    fog:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/foregroundfoglayer.png?v=1778850332',
    entryBase:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/entrybaseobject.png?v=1778850332',
    entrySymbol:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/entrysymbol.png?v=1778850330',
    entryCracks:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/entrycracks.png?v=1778850331',
    portalFrame:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/portalwheelframe.png?v=1778850332',
    core:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/portalcentercore.png?v=1778850331',
    legendary:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/legendarywheelicon.png?v=1778771563',
    wheelPlus:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/wheelplusicon.png?v=1776094429',
    vortexPro:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/vortexproicon.png?v=1776094430',
    badge:'https://cdn.shopify.com/s/files/1/0709/3675/6398/files/raritybadge1.png?v=1778850331'
  };

  const DEFAULT_SEGMENTS = [
    makeSegment('Gremlin Snack', '#FF5B9D', '#FFF1C9', ASSETS.legendary, 'A tiny snack token crackles inside the portal.'),
    makeSegment('Lucky Dare', '#43E7FF', '#111021', ASSETS.wheelPlus, 'A dare card hums with terrible little confidence.'),
    makeSegment('Secret Quest', '#FFD166', '#201104', ASSETS.vortexPro, 'A folded quest note appears with glitter on the edges.'),
    makeSegment('Mystery Message', '#7CFFB2', '#07160D', ASSETS.badge, 'A secret message waits for the person who opens this world.'),
    makeSegment('Badge Drop', '#A78BFA', '#FFFFFF', ASSETS.legendary, 'A shiny badge falls out of the portal smoke.'),
    makeSegment('Remix This', '#FF8A3D', '#1D0902', ASSETS.wheelPlus, 'A remix token lets this world mutate into something stranger.')
  ];

  function makeSegment(title, color, titleColor, stickerUrl, itemText){
    return {
      title, color, titleColor, stickerUrl,
      itemType:'image',
      itemImageUrl:stickerUrl,
      itemVideoUrl:'',
      itemAudioUrl:'',
      itemText:itemText || 'Something strange was left inside this segment.',
      cardTitle:title + ' Unlocked',
      cardText:'The portal chose this result and turned it into a collectible token.',
      tokenName:title + ' Token',
      tokenIconUrl:stickerUrl
    };
  }

  function init(){
    const root = document.getElementById('spin-world-root');
    if(!root || root.dataset.swV19Ready) return;
    root.dataset.swV19Ready = '1';

    const state = {
      mode:'entry',
      activeTab:'segment',
      editIndex:0,
      rotation:0,
      isSpinning:false,
      winnerIndex:null,
      segments: JSON.parse(JSON.stringify(window.SPIN_WORLD_SEGMENTS || DEFAULT_SEGMENTS))
    };

    root.innerHTML = template();
    const q = (sel) => root.querySelector(sel);
    const qa = (sel) => Array.from(root.querySelectorAll(sel));

    const wheelSvg = q('[data-wheel-svg]');
    const pullStage = q('[data-pull-stage]');
    const pullSvg = q('[data-pull-svg]');
    const itemOverlay = q('[data-item-overlay]');
    const cardOverlay = q('[data-card-overlay]');
    const hint = q('[data-result-hint]');
    const explosion = q('[data-explosion]');

    function template(){
      return `
        <div class="sw-v19-shell">
          <main class="sw-phone" data-phone>
            <img class="sw-bg" src="${ASSETS.bg}" alt="" aria-hidden="true">
            <img class="sw-fog" src="${ASSETS.fog}" alt="" aria-hidden="true">
            <img class="sw-fog sw-fog--front" src="${ASSETS.fog}" alt="" aria-hidden="true">

            <div class="sw-topbar">
              <div class="sw-pill" data-status-pill>Spin World</div>
              <button class="sw-iconBtn" type="button" data-open-builder aria-label="Customize Spin World">✦</button>
            </div>

            <section class="sw-screen sw-entryScreen" data-screen="entry">
              <button class="sw-entryObject" type="button" data-break-seal aria-label="Break the seal">
                <img class="sw-entryBase" src="${ASSETS.entryBase}" alt="" aria-hidden="true">
                <img class="sw-entryCracks" src="${ASSETS.entryCracks}" alt="" aria-hidden="true">
                <img class="sw-entrySymbol" src="${ASSETS.entrySymbol}" alt="" aria-hidden="true">
              </button>
              <h1 class="sw-entryTitle">A Spin World<br>was left for you.</h1>
              <p class="sw-entrySub">Break the seal, spin the portal, and see what strange little thing was hidden inside.</p>
              <div class="sw-actions">
                <button class="sw-primary" type="button" data-break-seal>Break the Seal</button>
                <button class="sw-secondary" type="button" data-open-builder>Customize</button>
              </div>
            </section>

            <section class="sw-screen sw-portalScreen" data-screen="portal" hidden>
              <div class="sw-portalHeader">
                <h2>Spin the Portal</h2>
                <p>Segment titles and stickers live directly on the slices.</p>
              </div>
              <div class="sw-portalRig" data-portal-rig>
                <div class="sw-portalAura"></div>
                <div class="sw-pointer"></div>
                <div class="sw-wheelWrap"><svg class="sw-wheelSvg" data-wheel-svg viewBox="0 0 1000 1000" role="img" aria-label="Spin World wheel"></svg></div>
                <img class="sw-portalFrame" src="${ASSETS.portalFrame}" alt="" aria-hidden="true">
                <img class="sw-centerCore" src="${ASSETS.core}" alt="" aria-hidden="true">
                <div class="sw-pullStage" data-pull-stage>
                  <div class="sw-pullBeam"></div>
                  <svg class="sw-pulledSvg" data-pull-svg viewBox="0 0 1000 1000" aria-hidden="true"></svg>
                </div>
              </div>
              <div class="sw-spinRow">
                <button class="sw-primary" type="button" data-spin>Spin the Portal</button>
                <button class="sw-secondary" type="button" data-open-builder>Build</button>
              </div>
              <div class="sw-resultHint" data-result-hint></div>
            </section>

            <section class="sw-screen sw-builderScreen" data-screen="builder" hidden>
              <div class="sw-builderPanel">
                <div class="sw-builderHead">
                  <h2>Quick Tweaks</h2>
                  <p>Edit each segment, the item hidden inside it, and the final reveal card.</p>
                </div>
                <div class="sw-tabs">
                  <button class="sw-tab" type="button" data-tab="segment">Segment</button>
                  <button class="sw-tab" type="button" data-tab="item">Item</button>
                  <button class="sw-tab" type="button" data-tab="card">Card</button>
                </div>
                <div class="sw-editorScroll">
                  <div class="sw-segmentSelectRow">
                    <select class="sw-select" data-segment-picker></select>
                    <button class="sw-smallBtn" type="button" data-add-segment>+</button>
                    <button class="sw-smallBtn" type="button" data-remove-segment>−</button>
                  </div>

                  <div class="sw-fieldset" data-fieldset="segment">
                    <div class="sw-field"><label>Segment name</label><input class="sw-input" data-bind="title" maxlength="34"></div>
                    <div class="sw-two">
                      <div class="sw-field"><label>Segment color</label><input class="sw-input" data-bind="color" type="color"></div>
                      <div class="sw-field"><label>Title color</label><input class="sw-input" data-bind="titleColor" type="color"></div>
                    </div>
                    <div class="sw-field"><label>Sticker image URL</label><input class="sw-input" data-bind="stickerUrl" placeholder="https://..."><p class="sw-help">This image sits on the segment, like your sticker system.</p></div>
                  </div>

                  <div class="sw-fieldset" data-fieldset="item">
                    <div class="sw-field"><label>Item type</label><select class="sw-select" data-bind="itemType"><option value="image">Image / gift</option><option value="video">Video</option><option value="audio">Voice note / audio</option><option value="note">Written note</option></select></div>
                    <div class="sw-field"><label>Item image URL</label><input class="sw-input" data-bind="itemImageUrl" placeholder="https://..."></div>
                    <div class="sw-field"><label>Video URL</label><input class="sw-input" data-bind="itemVideoUrl" placeholder="https://..."></div>
                    <div class="sw-field"><label>Audio URL</label><input class="sw-input" data-bind="itemAudioUrl" placeholder="https://..."></div>
                    <div class="sw-field"><label>Item message</label><textarea class="sw-textarea" data-bind="itemText"></textarea><p class="sw-help">Ideas: photo, short video, voice note, joke, dare, coupon, birthday message, clue, badge, secret reward, or a tiny personal token.</p></div>
                  </div>

                  <div class="sw-fieldset" data-fieldset="card">
                    <div class="sw-field"><label>Reveal card title</label><input class="sw-input" data-bind="cardTitle" maxlength="42"></div>
                    <div class="sw-field"><label>Reveal card text</label><textarea class="sw-textarea" data-bind="cardText"></textarea></div>
                    <div class="sw-field"><label>Token name</label><input class="sw-input" data-bind="tokenName" maxlength="42"></div>
                    <div class="sw-field"><label>Token icon URL</label><input class="sw-input" data-bind="tokenIconUrl" placeholder="https://..."></div>
                  </div>
                </div>
                <div class="sw-builderFoot">
                  <button class="sw-secondary" type="button" data-back-portal>Back to Portal</button>
                  <button class="sw-primary" type="button" data-preview-spin>Preview Spin</button>
                </div>
              </div>
            </section>

            <div class="sw-explosion" data-explosion></div>
            <div class="sw-itemOverlay" data-item-overlay hidden></div>
            <div class="sw-cardOverlay" data-card-overlay hidden></div>
          </main>
        </div>`;
    }

    function showScreen(name){
      state.mode = name;
      qa('[data-screen]').forEach(s => s.hidden = s.dataset.screen !== name);
      q('[data-status-pill]').textContent = name === 'builder' ? 'Quick Tweaks' : name === 'portal' ? 'Portal Open' : 'Spin World';
      if(name === 'builder') renderBuilder();
      if(name === 'portal') renderWheel();
    }

    function breakSeal(){
      const obj = q('.sw-entryObject');
      obj.classList.add('is-cracking');
      setTimeout(() => showScreen('portal'), 760);
    }

    function polar(cx, cy, r, angleDeg){
      const rad = (angleDeg - 90) * Math.PI / 180;
      return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
    }

    function wedgePath(start, end, outer=455, inner=104){
      const large = (end - start) > 180 ? 1 : 0;
      const o1 = polar(500,500,outer,start), o2 = polar(500,500,outer,end);
      const i2 = polar(500,500,inner,end), i1 = polar(500,500,inner,start);
      return `M ${o1.x.toFixed(2)} ${o1.y.toFixed(2)} A ${outer} ${outer} 0 ${large} 1 ${o2.x.toFixed(2)} ${o2.y.toFixed(2)} L ${i2.x.toFixed(2)} ${i2.y.toFixed(2)} A ${inner} ${inner} 0 ${large} 0 ${i1.x.toFixed(2)} ${i1.y.toFixed(2)} Z`;
    }

    function linesFor(title){
      const words = String(title || '').trim().split(/\s+/).filter(Boolean);
      if(words.length <= 1) return [title || 'Segment'];
      if(words.length === 2) return words;
      const mid = Math.ceil(words.length / 2);
      return [words.slice(0, mid).join(' '), words.slice(mid).join(' ')];
    }

    function renderWheel(){
      const segs = state.segments;
      const n = Math.max(segs.length, 2);
      const step = 360 / n;
      const svg = wheelSvg;
      svg.innerHTML = '';
      svg.style.transform = `rotate(${state.rotation}deg)`;
      svg.style.setProperty('--sw-final-rot', `rotate(${state.rotation}deg)`);
      segs.forEach((seg, i) => {
        const start = i * step;
        const end = (i + 1) * step;
        const mid = start + step / 2;
        const g = document.createElementNS('http://www.w3.org/2000/svg','g');
        g.setAttribute('data-seg-index', i);
        const path = document.createElementNS('http://www.w3.org/2000/svg','path');
        path.setAttribute('class','sw-segPath');
        path.setAttribute('d', wedgePath(start, end));
        path.setAttribute('fill', seg.color || '#FF5B9D');
        g.appendChild(path);

        const labelPos = polar(500,500,302,mid);
        const text = document.createElementNS('http://www.w3.org/2000/svg','text');
        text.setAttribute('class','sw-segLabel');
        text.setAttribute('x', labelPos.x.toFixed(1));
        text.setAttribute('y', labelPos.y.toFixed(1));
        text.setAttribute('fill', seg.titleColor || '#fff');
        text.setAttribute('font-size', n > 8 ? '37' : n > 6 ? '43' : '50');
        text.setAttribute('text-anchor','middle');
        text.setAttribute('transform', `rotate(${mid} ${labelPos.x.toFixed(1)} ${labelPos.y.toFixed(1)})`);
        linesFor(seg.title).slice(0,2).forEach((line, li) => {
          const tspan = document.createElementNS('http://www.w3.org/2000/svg','tspan');
          tspan.setAttribute('x', labelPos.x.toFixed(1));
          tspan.setAttribute('dy', li === 0 ? '-0.24em' : '1.08em');
          tspan.textContent = line.toUpperCase();
          text.appendChild(tspan);
        });
        g.appendChild(text);

        if(seg.stickerUrl){
          const stickerPos = polar(500,500,210,mid);
          const img = document.createElementNS('http://www.w3.org/2000/svg','image');
          img.setAttribute('class','sw-segSticker');
          img.setAttribute('href', seg.stickerUrl);
          img.setAttribute('x', (stickerPos.x - 42).toFixed(1));
          img.setAttribute('y', (stickerPos.y - 42).toFixed(1));
          img.setAttribute('width','84');
          img.setAttribute('height','84');
          img.setAttribute('preserveAspectRatio','xMidYMid meet');
          img.setAttribute('transform', `rotate(${mid} ${stickerPos.x.toFixed(1)} ${stickerPos.y.toFixed(1)})`);
          g.appendChild(img);
        }
        svg.appendChild(g);
      });
    }

    function renderPullSegment(index){
      const segs = state.segments;
      const n = Math.max(segs.length, 2);
      const step = 360 / n;
      const seg = segs[index];
      const start = index * step;
      const end = (index + 1) * step;
      const mid = start + step / 2;
      pullSvg.innerHTML = '';
      const wrap = document.createElementNS('http://www.w3.org/2000/svg','g');
      wrap.setAttribute('transform', `rotate(${state.rotation} 500 500)`);
      const path = document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('class','sw-pulledPath');
      path.setAttribute('d', wedgePath(start, end));
      path.setAttribute('fill', seg.color || '#FF5B9D');
      wrap.appendChild(path);

      const labelPos = polar(500,500,304,mid);
      const text = document.createElementNS('http://www.w3.org/2000/svg','text');
      text.setAttribute('class','sw-segLabel');
      text.setAttribute('x', labelPos.x.toFixed(1));
      text.setAttribute('y', labelPos.y.toFixed(1));
      text.setAttribute('fill', seg.titleColor || '#fff');
      text.setAttribute('font-size','52');
      text.setAttribute('text-anchor','middle');
      text.setAttribute('transform', `rotate(${mid} ${labelPos.x.toFixed(1)} ${labelPos.y.toFixed(1)})`);
      linesFor(seg.title).slice(0,2).forEach((line, li) => {
        const tspan = document.createElementNS('http://www.w3.org/2000/svg','tspan');
        tspan.setAttribute('x', labelPos.x.toFixed(1));
        tspan.setAttribute('dy', li === 0 ? '-0.24em' : '1.08em');
        tspan.textContent = line.toUpperCase();
        text.appendChild(tspan);
      });
      wrap.appendChild(text);

      if(seg.stickerUrl){
        const stickerPos = polar(500,500,210,mid);
        const img = document.createElementNS('http://www.w3.org/2000/svg','image');
        img.setAttribute('class','sw-pulledSticker');
        img.setAttribute('href', seg.stickerUrl);
        img.setAttribute('x', (stickerPos.x - 54).toFixed(1));
        img.setAttribute('y', (stickerPos.y - 54).toFixed(1));
        img.setAttribute('width','108');
        img.setAttribute('height','108');
        img.setAttribute('preserveAspectRatio','xMidYMid meet');
        img.setAttribute('transform', `rotate(${mid} ${stickerPos.x.toFixed(1)} ${stickerPos.y.toFixed(1)})`);
        wrap.appendChild(img);
      }
      pullSvg.appendChild(wrap);
    }

    function spin(){
      if(state.isSpinning || state.segments.length < 2) return;
      state.isSpinning = true;
      hideReveals();
      hint.textContent = 'The portal is choosing...';
      const n = state.segments.length;
      const chosen = Math.floor(Math.random() * n);
      state.winnerIndex = chosen;
      const step = 360 / n;
      const mid = chosen * step + step / 2;
      const currentNorm = ((state.rotation % 360) + 360) % 360;
      const desiredNorm = (360 - mid) % 360;
      const delta = ((desiredNorm - currentNorm + 360) % 360) + 360 * (5 + Math.floor(Math.random()*2));
      state.rotation += delta;
      const rig = q('[data-portal-rig]');
      rig.classList.add('is-spinning');
      wheelSvg.classList.remove('is-jiggling');
      wheelSvg.classList.add('is-spinning');
      wheelSvg.style.transform = `rotate(${state.rotation}deg)`;
      wheelSvg.style.setProperty('--sw-final-rot', `rotate(${state.rotation}deg)`);

      setTimeout(() => {
        wheelSvg.classList.remove('is-spinning');
        rig.classList.remove('is-spinning');
        wheelSvg.classList.add('is-jiggling');
        hint.textContent = 'Hold... the slice is stuck in the portal.';
      }, 4900);

      setTimeout(() => {
        renderPullSegment(chosen);
        pullStage.classList.remove('is-active');
        void pullStage.offsetWidth;
        pullStage.classList.add('is-active');
        hint.textContent = 'Pulling the winning segment out...';
      }, 5650);

      setTimeout(() => {
        burstConfetti();
        hint.textContent = '';
      }, 8580);

      setTimeout(() => {
        pullStage.classList.remove('is-active');
        showItem(chosen);
        state.isSpinning = false;
      }, 9000);
    }

    function hideReveals(){
      itemOverlay.hidden = true;
      cardOverlay.hidden = true;
      itemOverlay.innerHTML = '';
      cardOverlay.innerHTML = '';
      explosion.innerHTML = '';
    }

    function showItem(index){
      const seg = state.segments[index];
      let media = '';
      if(seg.itemType === 'video' && seg.itemVideoUrl){
        media = `<video src="${escapeAttr(seg.itemVideoUrl)}" controls playsinline></video>`;
      }else if(seg.itemType === 'audio' && seg.itemAudioUrl){
        media = `<audio src="${escapeAttr(seg.itemAudioUrl)}" controls></audio>`;
      }else if(seg.itemType === 'note'){
        media = `<div class="sw-noteItem">${escapeHtml(seg.itemText || 'A note was left inside.')}</div>`;
      }else{
        media = `<img src="${escapeAttr(seg.itemImageUrl || seg.stickerUrl || ASSETS.legendary)}" alt="Hidden item">`;
      }
      itemOverlay.innerHTML = `
        <div class="sw-itemBox">
          <div class="sw-itemMedia">${media}</div>
          <div class="sw-itemContent">
            <div class="sw-kicker">ITEM LEFT INSIDE</div>
            <h3>${escapeHtml(seg.title)}</h3>
            <p>${escapeHtml(seg.itemText || 'Something was left inside this segment.')}</p>
            <div class="sw-miniActions">
              <button class="sw-primary" type="button" data-open-card>Open Reveal Card</button>
              <button class="sw-secondary" type="button" data-close-item>Not yet</button>
            </div>
          </div>
        </div>`;
      itemOverlay.hidden = false;
    }

    function showCard(index){
      const seg = state.segments[index];
      cardOverlay.innerHTML = `
        <div class="sw-revealCard">
          <div class="sw-itemMedia"><img src="${escapeAttr(seg.tokenIconUrl || seg.stickerUrl || ASSETS.legendary)}" alt="Token"></div>
          <div class="sw-cardContent">
            <div class="sw-kicker">FINAL REVEAL CARD</div>
            <h3>${escapeHtml(seg.cardTitle || seg.title + ' Unlocked')}</h3>
            <p>${escapeHtml(seg.cardText || 'The portal turned this result into a collectible reveal card.')}</p>
            <div class="sw-cardToken"><img src="${escapeAttr(seg.tokenIconUrl || seg.stickerUrl || ASSETS.legendary)}" alt=""><span>${escapeHtml(seg.tokenName || 'Portal Token')}</span></div>
            <div class="sw-miniActions">
              <button class="sw-primary" type="button" data-spin-again>Spin Again</button>
              <button class="sw-secondary" type="button" data-open-builder>Remix</button>
            </div>
          </div>
        </div>`;
      itemOverlay.hidden = true;
      cardOverlay.hidden = false;
    }

    function burstConfetti(){
      explosion.innerHTML = '';
      const colors = ['#fff1b8','#ffd166','#ff4d8d','#43e7ff','#7cffb2','#a78bfa'];
      for(let i=0;i<70;i++){
        const p = document.createElement('i');
        p.className = 'sw-confettiPiece';
        const angle = Math.random() * Math.PI * 2;
        const dist = 90 + Math.random()*250;
        p.style.background = colors[i % colors.length];
        p.style.setProperty('--dx', `${Math.cos(angle)*dist}px`);
        p.style.setProperty('--dy', `${Math.sin(angle)*dist}px`);
        p.style.setProperty('--rot', `${Math.random()*760 - 380}deg`);
        p.style.animationDelay = `${Math.random()*0.12}s`;
        explosion.appendChild(p);
      }
      setTimeout(() => explosion.innerHTML = '', 1400);
    }

    function renderBuilder(){
      qa('.sw-tab').forEach(btn => btn.classList.toggle('is-active', btn.dataset.tab === state.activeTab));
      qa('.sw-fieldset').forEach(fs => fs.classList.toggle('is-active', fs.dataset.fieldset === state.activeTab));
      const picker = q('[data-segment-picker]');
      picker.innerHTML = state.segments.map((s,i)=>`<option value="${i}">${i+1}. ${escapeHtml(s.title || 'Segment')}</option>`).join('');
      picker.value = String(state.editIndex);
      const seg = state.segments[state.editIndex];
      qa('[data-bind]').forEach(input => {
        const key = input.dataset.bind;
        input.value = seg[key] || '';
      });
    }

    function updateBound(target){
      const key = target.dataset.bind;
      if(!key) return;
      state.segments[state.editIndex][key] = target.value;
      renderWheel();
      const picker = q('[data-segment-picker]');
      if(key === 'title' && picker) picker.options[state.editIndex].textContent = `${state.editIndex+1}. ${target.value || 'Segment'}`;
    }

    function addSegment(){
      state.segments.push(makeSegment('New Portal', '#43E7FF', '#FFFFFF', ASSETS.legendary, 'A new hidden item waits here.'));
      state.editIndex = state.segments.length - 1;
      renderBuilder(); renderWheel();
    }

    function removeSegment(){
      if(state.segments.length <= 2) return;
      state.segments.splice(state.editIndex,1);
      state.editIndex = Math.max(0, Math.min(state.editIndex, state.segments.length - 1));
      renderBuilder(); renderWheel();
    }

    function escapeHtml(str){
      return String(str == null ? '' : str).replace(/[&<>"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
    }
    function escapeAttr(str){ return escapeHtml(str).replace(/'/g, '&#039;'); }

    root.addEventListener('click', (e) => {
      const t = e.target.closest('button');
      if(!t) return;
      if(t.matches('[data-break-seal]')) breakSeal();
      if(t.matches('[data-open-builder]')) showScreen('builder');
      if(t.matches('[data-back-portal]')) showScreen('portal');
      if(t.matches('[data-spin], [data-preview-spin], [data-spin-again]')) { showScreen('portal'); setTimeout(spin, 60); }
      if(t.matches('[data-add-segment]')) addSegment();
      if(t.matches('[data-remove-segment]')) removeSegment();
      if(t.matches('[data-tab]')) { state.activeTab = t.dataset.tab; renderBuilder(); }
      if(t.matches('[data-open-card]')) showCard(state.winnerIndex == null ? 0 : state.winnerIndex);
      if(t.matches('[data-close-item]')) itemOverlay.hidden = true;
    });

    root.addEventListener('input', (e) => updateBound(e.target));
    root.addEventListener('change', (e) => {
      if(e.target.matches('[data-segment-picker]')) { state.editIndex = Number(e.target.value) || 0; renderBuilder(); }
      updateBound(e.target);
    });

    renderWheel();
    renderBuilder();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
